import { OrganizationBase } from '../organization/OrganizationBase';
import { ProjectBase } from '../project/ProjectBase';
import { UserBase, UserBaseProps } from './UserBase';

interface SearchUserProps extends UserBaseProps {
  organization: OrganizationBase;
  projects: ProjectBase[];
}

export class User extends UserBase {
  private _organization: OrganizationBase;
  private _projects: ProjectBase[];

  private constructor(props: SearchUserProps, id: string) {
    super(props, id);
    this._organization = props.organization;
    this._projects = props.projects;
  }

  get organization(): OrganizationBase {
    return this._organization;
  }

  get projects(): ProjectBase[] {
    return this._projects;
  }

  static override create(props: SearchUserProps, id: string): User {
    return new User(props, id);
  }
}
